import {groupCompatibilityStatus, isMatchActive, statuses} from "business/matching";
import CtaButton from "components/redesign/CtaButton";
import _, {find} from 'lodash';
import React, {useState} from 'react';
import {useTranslation} from "react-i18next";

const BLOCKED_COMPATIBILITIES = [
  groupCompatibilityStatus.INCOMPATIBLE,
  groupCompatibilityStatus.GROUP_FULL,
  groupCompatibilityStatus.PAIR_COMPLETE,
];

const MentorMatchSubmitButton = ({matches, submit}) => {
  const {t} = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const allMatchesMade = !_.find(matches, match => match.status === statuses.ACTIVE
    && !(_.get(match, 'interestStatus', false) || BLOCKED_COMPATIBILITIES.includes(_.get(match, 'groupCompatibility'))));
  const anyActiveMatch = find(matches, isMatchActive);

  if (!anyActiveMatch) {
    return null;
  }

  return (
    <CtaButton
      size={'large'}
      className={'matching-submit'}
      label={t('confirmChoices')}
      disabled={!allMatchesMade}
      loading={isSubmitting}
      onClick={async () => {
        setIsSubmitting(true);
        try {
          await submit();
        } finally {
          setIsSubmitting(false);
        }
      }}/>
  )
};

export default MentorMatchSubmitButton
